export default function ({ $auth, redirect }) {
    if (!process.env.MAINTENANCE) {
        return redirect('/')
    }
}
